(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-404"]) return;
  try {
    
  document.querySelectorAll('[data-404-search]').forEach(function (form) {
    const input = form.querySelector('input[name="q"]');
    const hint = document.querySelector('[data-404-hint]');
    if (!input || input.value) return;

    const parts = window.location.pathname.split('/').filter(Boolean);
    if (parts.indexOf('products') === -1 && parts.indexOf('collections') === -1) return;

    let slug = parts[parts.length - 1] || '';
    try {
      slug = decodeURIComponent(slug);
    } catch (error) {
      /* a malformed escape sequence just means no guess */
    }

    const term = slug
      .replace(/\.(js|json|html?)$/, '')
      .replace(/[-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
    if (term.length < 3) return;

    input.value = term;
    if (hint) hint.hidden = false;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-addresses"]) return;
  try {
    
  document.querySelectorAll('select[data-default-country]').forEach(function (select) {
    const country = select.getAttribute('data-default-country');
    if (country) select.value = country;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  document.querySelectorAll('[data-universe-grid]').forEach(function (grid) {
    const page = grid.closest('[data-section-id]');
    if (!page) return;
    const wrap = page.querySelector('[data-universe-filter]');
    const sort = page.querySelector('[data-universe-sort]');
    const none = page.querySelector('[data-universe-none]');
    const tally = wrap ? wrap.querySelector('[data-universe-tally]') : null;
    const input = wrap ? wrap.querySelector('input') : null;
    const select = sort ? sort.querySelector('[data-universe-sort-select]') : null;

    /* "Alle sæt" is not a theme: it is excluded from the alphabet and from the
       tally, and it stays where it is no matter what the other tiles do. */
    const tiles = Array.prototype.slice.call(grid.children).filter(function (tile) {
      return !tile.hasAttribute('data-universe-pinned');
    });

    const one = wrap ? wrap.getAttribute('data-tally-one') || '' : '';
    const other = wrap ? wrap.getAttribute('data-tally-other') || '' : '';

    function tallyText(n) {
      return (n === 1 ? one : other).replace(/\d+/, String(n));
    }

    function nameOf(tile) {
      return tile.getAttribute('data-universe-name') || '';
    }

    function applySort() {
      if (!select) return;
      const mode = select.value;
      const ordered = tiles.slice();
      if (mode === 'az' || mode === 'za') {
        /* Danish, so that æ, ø and å land after z where a Dane looks for
           them rather than next to a, o and a. */
        ordered.sort(function (a, b) {
          return nameOf(a).localeCompare(nameOf(b), 'da');
        });
        if (mode === 'za') ordered.reverse();
      } else {
        ordered.sort(function (a, b) {
          return Number(a.getAttribute('data-universe-order')) - Number(b.getAttribute('data-universe-order'));
        });
      }
      /* One fragment, one insertion: moving fifty tiles one at a time makes
         the browser lay the grid out fifty times. */
      const frag = document.createDocumentFragment();
      ordered.forEach(function (tile) {
        frag.appendChild(tile);
      });
      grid.appendChild(frag);
    }

    function applyFilter() {
      const term = input ? input.value.trim().toLowerCase() : '';
      let shown = 0;
      tiles.forEach(function (tile) {
        const match = !term || nameOf(tile).indexOf(term) !== -1;
        tile.hidden = !match;
        if (match) shown += 1;
      });
      if (none) none.hidden = shown !== 0;
      if (tally) tally.textContent = tallyText(shown);
    }

    if (wrap) {
      wrap.hidden = false;
      input.addEventListener('input', applyFilter);
      input.addEventListener('search', applyFilter);
    }
    if (sort) {
      sort.hidden = false;
      select.addEventListener('change', function () {
        applySort();
        applyFilter();
      });
    }

    applyFilter();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class KhTrustbox extends HTMLElement {
    connectedCallback() {
      this.widget = this.querySelector('.trustpilot-widget');
      if (!this.widget) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.observer.disconnect();
          this.load();
        },
        { rootMargin: '600px 0px' }
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    load() {
      if (window.Trustpilot) {
        window.Trustpilot.loadFromElement(this.widget, true);
        return;
      }

      const existing = document.querySelector('script[data-trustpilot-bootstrap]');
      if (existing) {
        existing.addEventListener('load', () => this.load(), { once: true });
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      script.dataset.trustpilotBootstrap = 'true';
      script.addEventListener('load', () => this.load(), { once: true });
      document.head.appendChild(script);
    }
  }

  if (!customElements.get('kh-trustbox')) {
    customElements.define('kh-trustbox', KhTrustbox);
  }

  } catch(e) { console.error(e); }
})();
})();
